export const theme = {
    color: {
        white: {
            soft: "#DDDDDD",
            pure: "#FFFFFF"
        },
        grey: {
            dark: "#979797",
            light: "#97979720"
        },
        silver: "#AAAAAA",
        gold: "#BD9B4E",
        highlight: "#D1AD665A",
        search: "#F8F412",
        rune: "#CA8120",
        unique: "#86735A",
        set: "#1B9718",
        darkGreen: "#135F11",
        required: "#9D4A3C",
        magic: "#4F53C5",
        value: "#8470ff",
        brown: "#885C02",
        black: {
            dark: "#000000",
            deep: "#0000009A",
            medium: "#0000007A",
            light: "#0000004A"
        }
    },
    breakpoint: {
        laptop: "1480px",
        tabletTwo: "1322px",
        tablet: "1170px",
        tabletPortrait: "990px",
        phoneTwo: "900px",
        phone: "767px",
        phonePortrait: "481px"
    },
    fontWeight: {
        regular: "400",
        medium: "500",
        bold: "700",
    },
    fontSize: {
        xxs: "6px",
        xs: "9px",
        s: "11px",
        m: "13px",
        l: "15px",
        xl: "18px",
        xl2: "20px",
        xl3: "24px",
        xl4: "30px",
        xl5: "40px",
    }
};